import React from 'react';
import $ from '../../../common/AjaxRequest';
import { Modal, Button, Table, message, Radio } from 'antd';
import API_URL from '../../../common/url';
import ExportUtil from '../../../common/ExportUtil';
const RadioGroup = Radio.Group;

class PortalExport extends React.Component {
    state = {
        visible: false,
        data: [],
        params: {},
        pagination: {
            pageSize: 15,
            current: 1,
        },
        loading: false,
        value: '',
    };

    show = () => {
        this.setState({
            visible: true,
        });
    };

    hide = () => {
        this.setState({
            visible: false,
            loading: false,
            params: {},
            value: '',
        });
    };

    submit = () => {
        const { value } = this.state;
        const { sortParams, searchParams } = this.props;
        const params = {
            ...sortParams,
            ...searchParams,
        }
        if (value === 'exportPortalUserEfficiency') {
            this.addToDownloadSite(params, API_URL.user.exportPortalUserEfficiency, 'Personal_Efficiency');
        } else {
            ExportUtil.export(params, null, API_URL.user.exportFactorAll);
            this.hide();
        }
    }

    addToDownloadSite = (searchArray, url, type) => {
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type },
            dataType: 'json',
            doneResult: res => {
                const { success, asynchronousExportId } = res;
                message.success(success);
                const params = { ...searchArray, asynchronousExportId }
                ExportUtil.export(params, null, url);
                this.hide();
            },
        };
        $.sendRequest(options);
    }

    handleChange = (e) => {
        this.setState({ value: e.target.value });
    }

    render() {
        const { visible, value } = this.state;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="350px"
            >
                <div style={{ display: 'flex', flexDirection: 'column', padding: '20px 35px'}}>
                    <div>请选择导出内容</div>
                    <RadioGroup 
                        style={{ display: 'flex', flexDirection: 'column',margin: '20px 60px 10px'}} 
                        onChange={e => this.handleChange(e)} 
                        value={value}
                    >
                        <Radio value="exportPortalUserEfficiency">人员效率</Radio>
                        <Radio value="exportFactorAll" style={{ marginTop: 10 }} >CRC空余率分析</Radio>
                    </RadioGroup>
                </div>
            </Modal>
        );
    }
}

export default PortalExport;



// WEBPACK FOOTER //
// ./src/components/user/userEfficiency/PortalExport.js